import { render } from "./Event.vue?vue&type=template&id=4e81c043"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"
script.render = render

export default script